import type { RibbonMenuButtonState } from "./RibbonFlyoutAnchor.types";

// eslint-disable-next-line no-restricted-imports
import type { AppMenuButtonProps } from "@1js/acui-button/lib/Next";

import { useRibbonButtonVariant } from "../../RibbonButton/next/useRibbonButtonVariant";
import { getDownChevronIcon } from "@1js/acui-icons";
import { checkExperiment, ribbonExperiments } from "@1js/acui-experiments";
import React from "react";
import { AppContext } from "@1js/acui-context";

export const useRibbonMenuButtonState = (
  props: AppMenuButtonProps,
  state: RibbonMenuButtonState
) => {
  const { variant, variantId } = props;
  const { size } = state;
  useRibbonButtonVariant(
    state,
    variant as RibbonMenuButtonState["variant"],
    variantId as RibbonMenuButtonState["variantId"]
  );

  if (
    state.variant === "ribbonModeButton" ||
    state.variant === "overflowButton"
  ) {
    // For ribbon mode flyout anchor & overflow buttons, we actually want it to be "icon only" and hide the menu icon
    state.iconOnly = true;
    state.root.children = undefined;
  }

  const context = React.useContext(AppContext);

  if (size === "large" && getDownChevronIcon(props) && state.menuIcon) {
    const checkForLabel = checkExperiment(
      context,
      ribbonExperiments.menuButtonIconForLargeFlyoutAnchorsEnabled
    );

    // Previous behavior before the ChangeGate
    if (!checkForLabel) {
      // Remove the menuIcon for large menu buttons
      // It gets rendered within the label itself (root.children)
      state.menuIcon.children = undefined;
    }

    // With the ChangeGate, add an additional check for if a Label exists in the state
    else if (checkForLabel && state.root.children) {
      // Remove the menuIcon for large menu buttons
      // It gets rendered within the label itself (root.children) if the label (root.children) exists
      state.menuIcon.children = undefined;
    }
  }

  return state;
};
